import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { DirectAddDomain } from '@app/modules/direct/models/direct-add-domain.interface';
import { SiteCreateResponse } from '@app/modules/direct/services/direct.service';

const steps: { label: string; completed: boolean }[] = [
  { label: 'Domain', completed: false },
  { label: 'Portfolio', completed: false },
  { label: 'Template', completed: false },
  { label: 'Title', completed: false },
  { label: 'Logo', completed: false },
  { label: 'Assets', completed: false },
];

@Injectable({
  providedIn: 'root',
})
export class DirectAddService {
  currentStep = -1;
  steps = structuredClone(steps);
  siteDomain?: DirectAddDomain;
  site?: SiteCreateResponse;

  constructor(private router: Router) {}

  nextStep() {
    this.currentStep = this.currentStep + 1;

    this.steps.forEach((step, index) => {
      if (index < this.currentStep) {
        step.completed = true;
      }
    });

    if (this.currentStep === this.steps.length) {
      this.router.navigate([`/direct/sites/${this.site?.id}/overview`, { siteAdded: true }]);
    }
  }

  goBack() {
    if (this.currentStep === -1) {
      this.router.navigate(['/direct']);
    } else {
      this.currentStep = this.currentStep - 1;
    }
  }

  setSiteDomain(siteDomain: DirectAddDomain) {
    this.siteDomain = siteDomain;
    this.nextStep();
  }

  setSite(site: SiteCreateResponse) {
    this.site = site;
    this.nextStep();
  }

  clean() {
    this.currentStep = -1;
    this.steps = structuredClone(steps);
    this.siteDomain = undefined;
    this.site = undefined;
  }
}
